import React, { useCallback, useEffect, useState } from "react";
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import s from './KeyListening.module.css';
import { useNavigate } from "react-router-dom";
import {RedButton, GreenButton, BlueButton} from './MyButton';
import addCirclePng from'../asset/add-circle.png';
import {Image} from 'react-bootstrap';
import {SoundPlayer} from'./Utilities/SoundPlayer.js';
import KeyListeningFile from'./KeyListeningFile.js';
import ListeningScriptGeneration from "./ListeningScriptGeneration.js";
import {Form} from 'react-bootstrap';

export default function KeyListening(prop) {	
	const navigate = useNavigate();
	
	let itemId = prop.itemId;
	let itemType = prop.itemType;
	
	const [srtPath, setSrtPath] = useState();
	const [srtHkPath, setSrtHkPath] = useState();
	const [audioPath, setAudioPath] = useState();
	
	const [srtNdPath, setSrtNdPath] = useState();
	const [srtNdHkPath, setSrtNdHkPath] = useState();
	const [audioNdPath, setAudioNdPath] = useState();
	
	const [studyTime, setStudyTime] = useState();
	const [tidyUpTime, setTidyUpTime] = useState();
	
	
	
	const [cMinute, setCMinute] = useState();
	const [cSecond, setCSecond] = useState();
	
	
	
	const [answerModel, setAnswerModel] = useState();
	const [pauseT1, setPauseT1] = useState({min:0 , sec:0 , totalSec:0});
	const [pauseT2, setPauseT2] = useState({min:0 , sec:0 , totalSec:0});
	const [pauseT3, setPauseT3] = useState({min:0 , sec:0 , totalSec:0});
	const [pauseT4, setPauseT4] = useState({min:0 , sec:0 , totalSec:0});
	const [pauseT5, setPauseT5] = useState({min:0 , sec:0 , totalSec:0});
	
	const [mainMessage, setMainMessage] = useState();
	const [mainMessageHk, setMainMessageHk] = useState();
	
	const [pdfPath, setPDFPath] = useState();
	
	const updatePause = async (index) => {
		let obj = { itemId };
		if (index == 0) {
			obj.index = index;
			obj.time = pauseT1.totalSec;
		}			
		console.log(obj);
		await postData("item/updateListeningPause", obj, navigate);
		
	}
	const clearPause = async (index) => {
		let obj = { itemId };
		if (index == 0) {
			obj.index = index;
		}			
		await postData("item/clearListeningPause", obj, navigate);
		setPauseT1({});
	}
	
	const generalItemUpload = async (selectedFile) => {
		try {
			const data = new FormData();
			data.append("itemId", itemId);
			data.append("generalfile", selectedFile);
			let res = await postFormData("utility/generalItemUpload", data, navigate);
			return res.data;
		} catch (err) {
			return null;
		}
	}
	
	const checkLinkValidity = async (fileUrl) => {    
    try {
      const response = await fetch(fileUrl);
      if (!response.ok) {
        return false;
      }
    } catch (error) {
      return false;
    }
		return true;
  };
	
	const convertSrt = async () => {
		let obj = {
			'itemId' : itemId,
		}
		await postData("item/processListeningHkSrt", obj, navigate); 
		fetchData();
	}

	const updateTime = async () => {
		let obj = { itemId, studyTime, tidyUpTime};
		await postData("item/updateKeyListeningTime", obj, navigate);
	}
	
	const extractFileName = (url) => {
    const pathname = new URL(url).pathname;
    const fileName = pathname.substring(pathname.lastIndexOf('/') + 1);
    return fileName;
  };
	
	
	const updateEN = async () => {
		let obj = { itemId, messageEn:mainMessage};
		await postData("item/updateKeyListening", obj, navigate);
	}
	
	const updateHk = async () => {
		let obj = { itemId, messageHk:mainMessageHk};
		await postData("item/updateKeyListening", obj, navigate);
	}
	
	const updateAnswerModel = async () => {
		let obj = { itemId, answerModel};
		await postData("listeningApi/updateAnswerModel", obj, navigate);
	}
	
	const translateUpdateHk = async () => {
		let obj = { sentence:mainMessage }
		let s = await postData("utility/translateSentence", obj, navigate); 
			
		let hk = s.data;
		setMainMessageHk(hk);
		obj = { itemId, messageHk:hk};
		await postData("item/updateKeyListening", obj, navigate);
		
	}

	const updateKeyListeningPDF = async (pdfPath) => {		
		let obj = { itemId, pdfPath};
		await postData("item/updateKeyListening", obj, navigate);
		setPDFPath("https://ehla-media-bucket.s3.amazonaws.com/" + pdfPath)
	}
	
	const updateKeyListeningAudioPath = async (audioPath) => {
		let obj = { itemId, audioPath};
		await postData("item/updateKeyListening", obj, navigate);
		setAudioPath("https://ehla-media-bucket.s3.amazonaws.com/" + audioPath)
	}

	const updateKeyListeningAudioNdPath = async (audioPath) => {
		let obj = { itemId, audioNdPath: audioPath};
		await postData("item/updateKeyListening", obj, navigate);
		setAudioNdPath("https://ehla-media-bucket.s3.amazonaws.com/" + audioPath)
	}
	
	const updateKeyListeningSrtPath = async (srtPath) => {
		let obj = { itemId, srtPath};
		await postData("item/updateKeyListening", obj, navigate);		
		setSrtPath("https://ehla-media-bucket.s3.amazonaws.com/" + srtPath);
	}
	
	const updateKeyListeningSrtHkPath = async (srtPath) => {
		let obj = { itemId, srtHkPath:srtPath};
		await postData("item/updateKeyListeningHk", obj, navigate);		
		setSrtHkPath("https://ehla-media-bucket.s3.amazonaws.com/" + srtPath);
	}
	
	
	const updateKeyListeningSrtNdHkPath = async (srtPath) => {
		let obj = { itemId, srtNdHkPath:srtPath};
		await postData("item/updateKeyListeningHk", obj, navigate);		
		setSrtNdHkPath("https://ehla-media-bucket.s3.amazonaws.com/" + srtPath);
	}

	const updateKeyListeningSrtNdPath = async (srtPath) => {
		let obj = { itemId, srtNdPath:srtPath};
		await postData("item/updateKeyListening", obj, navigate);		
		setSrtNdPath("https://ehla-media-bucket.s3.amazonaws.com/" + srtPath);
	}
	
	const fetchData = async () => {
		getData('item/getListeningByItemId?itemId=' + itemId, navigate)
		.then(res => {
				if (res.data.studyTime) { setStudyTime(res.data.studyTime); }
				if (res.data.tidyUpTime) { setTidyUpTime(res.data.tidyUpTime); }
				
				if (res.data.answerModel) { setAnswerModel(res.data.answerModel); }		
				if (res.data.pdfPath) { setPDFPath(res.data.pdfPath); }		
				if (res.data.mainMsg) { setMainMessage(res.data.mainMsg); }		
				if (res.data.mainMsgJson.msg_hk) { setMainMessageHk(res.data.mainMsgJson.msg_hk); }		
				
				if (res.data.audioPath) { setAudioPath(res.data.audioPath); }
				if (res.data.srtPath) { setSrtPath(res.data.srtPath); }		
				if (res.data.srtPathJson.hk) { setSrtHkPath(res.data.srtPathJson.hk); }		
				if (res.data.audioNdPath) { setAudioNdPath(res.data.audioNdPath); }
				if (res.data.srtNdPath) { setSrtNdPath(res.data.srtNdPath); }	
				if (res.data.srtPathJson.nd_hk) { setSrtNdHkPath(res.data.srtPathJson.nd_hk); }	
				
				if (res.data.pauseTimeJson) { 
					let pArray = res.data.pauseTimeJson;
					
					if (pArray[0]) {
						let min = Math.floor(parseInt(pArray[0]) / 60);
						let sec = parseInt(pArray[0]) % 60;
						let totalSec = parseInt(pArray[0]);
						setPauseT1({min , sec , totalSec});
					} else {
							setPauseT1({min:0 , sec:0 , totalSec:0});
					}
				}
			}
		);
	}
	
	useEffect(() => {
		fetchData();
	}, []);

	return (<div>
		<div style={{padding:"2px 0"}}>
			<div style={{border:"1px solid #22222222", margin:"10px"}}>
				<div style={{background:"#76B7EE", color:"white"}}>
					<h3>Time</h3>
				</div>
				<div>
					{
						(itemType == 74 || itemType == 96) && 
						(<div style={{display:"flex", alignItems:"center", justifyContent:"center", borderBottom:"1px solid #22222222"}}>
							<div style={{margin:"10px"}}>Study Time</div>
							<div style={{margin:"10px"}}>
								<input className={s.srtStartTime}  type="number" value={studyTime} onChange={(e)=>{
									setStudyTime(e.target.value);
								}}/>
							</div>
							<div style={{margin:"15px 0 0 -10px"}}>sec</div>
							<div style={{margin:"10px"}}>Tidy Time</div>
							<div style={{margin:"10px"}}>
								<input className={s.srtStartTime}  type="number" value={tidyUpTime} onChange={(e)=>{
									setTidyUpTime(e.target.value);
								}}/>
							</div>
							<div style={{margin:"15px 0 0 -10px"}}>sec</div>
							<div style={{margin:"10px"}}>
								<GreenButton isEnabled={true} clickedAction={()=>updateTime()} bText={"Update Time"} />
							</div>
						</div>)
					}
					{
						(itemType == 75) &&
						(<div>
							
							<div style={{display:"flex", alignItems:"center"}}>
								<div style={{margin:"0 5px"}}>Pause Time 1</div>
								
								
								
								
								<div style={{margin:"10px"}}>
									<input className={s.srtStartTime}  type="number" value={pauseT1.min} onChange={(e)=>{
										let uv = parseInt(e.target.value);
										
										if (isNaN(uv) || uv < 0) {
											uv = 0;
										}
										
										let totalSec = uv * 60 + pauseT1.sec;
										setPauseT1({...pauseT1, min:uv, totalSec});
									}}/>
								</div>
								<div style={{margin:"15px 0 0 -10px"}}>min</div>
								<div style={{margin:"10px"}}>
									<input className={s.srtStartTime}  type="number" value={pauseT1.sec} onChange={(e)=>{
										let uv = parseInt(e.target.value);
										
										if (isNaN(uv) || uv < 0) {
											uv = 0;
										} else if (uv > 60) {
											uv = 60;
										}
										
										let totalSec = pauseT1.min * 60 + uv;
										setPauseT1({...pauseT1, sec:uv, totalSec});
									}}/>
								</div>
								<div style={{margin:"15px 0 0 -10px"}}>sec</div>
								<div> = {pauseT1.totalSec}</div>
								
								<div style={{margin:"10px"}}>
									<GreenButton isEnabled={true} clickedAction={()=>updatePause(0)} bText={"Update"} />
								</div>
								<div style={{margin:"10px"}}>
									<GreenButton isEnabled={true} clickedAction={()=>clearPause(0)} bText={"Clear"} />
								</div>
							</div>
							
						</div>)
					}
				</div>

				{(itemType == 74|| itemType == 96) && (<>
					<div style={{background:"#76B7EE", color:"white"}}>
						<h3>Main Message</h3>
					</div>
					
					<div style={{borderBottom:"1px solid #22222222", textAlign:"Left"}}>
						<div style={{display:"flex", alignItems:"start", justifyContent:"start", margin:"10px"}}>
							<div style={{width:"50%", margin:"10px"}} >
								<div style={{fontSize:"22px", fontWeight:"bold"}}>EN</div>
								<textarea style={{border:"1px solid #22222222", width:"100%"}}  className={s.textAreaAuto} value={mainMessage} rows={3} wrap='off' onChange={(e) => {
									setMainMessage(e.target.value);
								}}/>
								<GreenButton isEnabled={true} clickedAction={()=>updateEN()} bText={"Update"} />
							</div>
							<div style={{width:"50%", margin:"10px"}} >
								<div style={{fontSize:"22px", fontWeight:"bold"}}>HK</div>
								<textarea style={{border:"1px solid #22222222", width:"100%"}}  className={s.textAreaAuto} value={mainMessageHk} rows={3} wrap='off' onChange={(e) => {
									setMainMessageHk(e.target.value);
								}}/>
								<div style={{display:"flex"}}>
									<div style={{marginRight:"10px"}} >
										<GreenButton isEnabled={true} clickedAction={()=>updateHk()} bText={"Update"} />
									</div>
									<div>
										<GreenButton isEnabled={true} clickedAction={()=>translateUpdateHk()} bText={"translate & update"} />
									</div>
								</div>
							</div>
						</div>
					</div>

					{(itemType == 96 || itemType == 74) && (<>
						<div style={{width:"50%", margin:"10px"}} >
							<div style={{fontSize:"22px", fontWeight:"bold"}}>Answer Model</div>
							<textarea style={{border:"1px solid #22222222", width:"100%"}}  className={s.textAreaAuto} value={answerModel} rows={3} wrap='off' onChange={(e) => {
								setAnswerModel(e.target.value);
							}}/>
							<GreenButton isEnabled={true} clickedAction={()=>updateAnswerModel()} bText={"Update"} />
						</div>



						<div style={{background:"#76B7EE", color:"white"}}>
							<h3>PDF</h3>
						</div>
						<KeyListeningFile itemId={itemId}/>

					</>)}


					{itemType == 74 && (<>
						<div style={{background:"#76B7EE", color:"white"}}>
							<h3>PDF</h3>
						</div>
						<div style={{borderBottom:"1px solid #22222222"}}>
						
							<div style={{display:"flex", alignItems:"center"}}>
								<label htmlFor="pdf-upload" className={s.custom_file_upload} style={{margin:"5px"}}>
									<input id="pdf-upload" type="file" style={{display:"none"}} onChange={
										async (e) => {
											let path = await generalItemUpload(e.target.files[0]);
											
											if (path) {
												updateKeyListeningPDF(path);
											}
										}} />
									Upload pdf
								</label>
							
								{	(pdfPath) && (<div style={{textAlign:"left"}}>
										<a style={{margin:"5px"}} href={pdfPath} download>{pdfPath}</a>
									</div>)
								}
								
								
							</div>
						</div>
					</>)}
				</>)}
				




				{/*}
				<div style={{background:"#76B7EE", color:"white"}}>
					<h3>{(itemType == 74|| itemType == 96) ? "First Part of listening" : "Podcast"}</h3>
				</div>
				<div style={{display:"flex", alignItems:"center"}}>
					<label htmlFor="srt-upload" className={s.custom_file_upload} style={{margin:"5px"}}>
					
						<input id="srt-upload" type="file" style={{display:"none"}} onChange={
							async (e) => {
								let path = await generalItemUpload(e.target.files[0]);
								
								if (path) {
									updateKeyListeningSrtPath(path);
								}
							}} />
						Upload srt
					</label>
					
					<label htmlFor="srt-upload-hk" className={s.custom_file_upload} style={{margin:"5px"}}>
					
						<input id="srt-upload-hk" type="file" style={{display:"none"}} onChange={
							async (e) => {
								let path = await generalItemUpload(e.target.files[0]);
								
								if (path) {
									updateKeyListeningSrtHkPath(path);
								}
							}} />
						Upload HK srt
					</label>
					
					
					
					
					
					
					<label htmlFor="audio-upload" className={s.custom_file_upload} style={{margin:"5px"}}>
						<input id="audio-upload" type="file" style={{display:"none"}} onChange={
							async (e) => {
								let path = await generalItemUpload(e.target.files[0]);
								if (path) {
									updateKeyListeningAudioPath(path);
								}
							}} />
						Upload audio
					</label>
				</div>
				
				<div style={{background:"#22222222", fontWeight:"bold", width:"100%", textAlign:"left"}}>article SRT</div>
				{	(srtPath) && (<div style={{textAlign:"left", display:"flex"}}>
						<div style={{margin:"5px"}} >
							<a href={srtPath} download>{srtPath}</a>
						</div>
						<div style={{margin:"5px 5px 5px auto"}}>
							<RedButton isEnabled={true} clickedAction={()=>setSrtPath(null)} bText={"X"} />
						</div>
					</div>)
				}
				<div style={{background:"#22222222", fontWeight:"bold", width:"100%", textAlign:"left"}}>article SRT HK</div>
				{	(srtHkPath) && (<div style={{textAlign:"left", display:"flex"}}>
						<div style={{margin:"5px"}} >
							<a href={srtHkPath} download>{srtHkPath}</a>
						</div>
						<div style={{margin:"5px 5px 5px auto"}}>
							<RedButton isEnabled={true} clickedAction={()=>setSrtHkPath(null)} bText={"X"} />
						</div>
					</div>)
				}
				
				<div style={{background:"#22222222", fontWeight:"bold", width:"100%", textAlign:"left"}}>mp3 upload</div>
				{	(audioPath) && (<div style={{textAlign:"left", margin:"5px", display:"flex"}}>
						<div style={{margin:"5px"}} >
							<SoundPlayer soundFile={audioPath}/>
						</div>
						<div style={{margin:"5px"}} >
							<a href={audioPath} download>{audioPath}</a>
						</div>
						<div style={{margin:"5px 5px 5px auto"}}>
							<RedButton isEnabled={true} clickedAction={()=>setAudioPath(null)} bText={"X"} />
						</div>
					</div>)
				}	
		*/}			
			</div>
		</div>
		
		{/*}
		{(itemType == 74|| itemType == 96) &&(<div style={{padding:"2px 0"}}>
			<div style={{border:"1px solid #22222222", margin:"10px"}}>
				<div style={{background:"#76B7EE", color:"white"}}>
					<h3>Second Part of listening</h3>
				</div>
				<div style={{display:"flex", alignItems:"center"}}>
					<label htmlFor="nd-srt-upload" className={s.custom_file_upload} style={{margin:"5px"}}>
					
						<input id="nd-srt-upload" type="file" style={{display:"none"}} onChange={
							async (e) => {
								let path = await generalItemUpload(e.target.files[0]);
								
								if (path) {
									updateKeyListeningSrtNdPath(path);
								}
							}} />
						Upload srt
					</label>
					
					<label htmlFor="nd-srt-upload-hk" className={s.custom_file_upload} style={{margin:"5px"}}>
					
						<input id="nd-srt-upload-hk" type="file" style={{display:"none"}} onChange={
							async (e) => {
								let path = await generalItemUpload(e.target.files[0]);
								
								if (path) {
									updateKeyListeningSrtNdHkPath(path);
								}
							}} />
						Upload HK srt
					</label>
					
					<label htmlFor="nd-audio-upload" className={s.custom_file_upload} style={{margin:"5px"}}>
						<input id="nd-audio-upload" type="file" style={{display:"none"}} onChange={
							async (e) => {
								let path = await generalItemUpload(e.target.files[0]);
								if (path) {
									updateKeyListeningAudioNdPath(path);
								}
							}} />
						Upload audio
					</label>
				</div>
				
				<div style={{background:"#22222222", fontWeight:"bold", width:"100%", textAlign:"left"}}>article SRT</div>
				{	(srtNdPath) && (<div style={{textAlign:"left", display:"flex"}}>
						<div style={{margin:"5px"}} >
							<a href={srtNdPath} download>{srtNdPath}</a>
						</div>
						<div style={{margin:"5px 5px 5px auto"}}>
							<RedButton isEnabled={true} clickedAction={()=>setSrtNdPath(null)} bText={"X"} />
						</div>
					</div>)
				}
				<div style={{background:"#22222222", fontWeight:"bold", width:"100%", textAlign:"left"}}>article HK SRT</div>
				{	(srtNdHkPath) && (<div style={{textAlign:"left", display:"flex"}}>
						<div style={{margin:"5px"}} >
							<a href={srtNdHkPath} download>{srtNdHkPath}</a>
						</div>
						<div style={{margin:"5px 5px 5px auto"}}>
							<RedButton isEnabled={true} clickedAction={()=>setSrtNdHkPath(null)} bText={"X"} />
						</div>
					</div>)
				}
				
				<div style={{background:"#22222222", fontWeight:"bold", width:"100%", textAlign:"left"}}>mp3 upload</div>
				{	(audioNdPath) && (<div style={{textAlign:"left", margin:"5px", display:"flex"}}>
						<div style={{margin:"5px"}} >
							<SoundPlayer soundFile={audioNdPath}/>
						</div>
						<div style={{margin:"5px"}} >
							<a href={audioNdPath} download>{audioNdPath}</a>
						</div>
						<div style={{margin:"5px 5px 5px auto"}}>
							<RedButton isEnabled={true} clickedAction={()=>setAudioNdPath(null)} bText={"X"} />
						</div>
					</div>)
				}				
			</div>
		</div>)
		}
		*/}

{/*
		<div style={{margin:"5px"}}>
			<GreenButton isEnabled={true} clickedAction={()=>convertSrt()} bText={"Convert Srt into HK"} />
		</div>*/}
		<ListeningScriptGeneration itemId={itemId} itemType={itemType}/>
		
	</div>);
	
}
